export const normalizeValidationResult = (result = {}) => {
  return {
    isComplete: result.isComplete ?? result.is_complete ?? false,

    extractedValue:
      result.extractedData ?? result.extracted_value ?? null,

    canonicalValue:
      result.canonicalData ?? result.canonical_data ?? null,

    missingFields:
      result.missingFields ?? result.missing_fields ?? [],

    clarificationQuestion:
      result.clarificationQuestion ??
      result.clarification_question ??
      null,
  }
}